import React from 'react';
import { Button } from '../../../components/base/Button';

export const SolutionsSection: React.FC = () => {
  const solutions = [
    {
      title: '대형 건설 프로젝트',
      description: '초고층 빌딩, 대형 인프라 프로젝트를 위한 종합 계측 솔루션',
      features: ['실시간 구조 안전성 모니터링', '지반 침하 예측 시스템', '환경 영향 평가', '통합 데이터 대시보드'],
      image: 'https://public.readdy.ai/ai/img_res/a0bdc4b105955552f619012ac6e9d088.jpg'
    },
    {
      title: '교량 및 터널',
      description: '교량과 터널의 구조적 건전성을 보장하는 전문 계측 시스템',
      features: ['변형 및 진동 모니터링', '균열 감지 시스템', '내하력 평가', '예방 정비 알림'],
      image: 'https://readdy.ai/api/search-image?query=Bridge%20and%20tunnel%20monitoring%20systems%2C%20sensors%20installed%20on%20concrete%20structures%2C%20professional%20engineering%20equipment%2C%20structural%20health%20monitoring%2C%20blue%20and%20white%20color%20scheme%2C%20clean%20industrial%20environment%2C%20advanced%20monitoring%20technology&width=800&height=600&seq=bridge-tunnel&orientation=landscape'
    },
    {
      title: '스마트 시티',
      description: '도시 인프라의 지능형 관리를 위한 IoT 기반 계측 네트워크',
      features: ['도시 전체 통합 모니터링', 'IoT 센서 네트워크', 'AI 기반 예측 분석', '시민 안전 보장'],
      image: 'https://readdy.ai/api/search-image?query=Smart%20city%20infrastructure%20with%20IoT%20monitoring%20network%2C%20connected%20sensors%20throughout%20urban%20environment%2C%20digital%20city%20management%2C%20futuristic%20urban%20planning%2C%20blue%20and%20white%20color%20scheme%2C%20modern%20technology%20integration%2C%20smart%20infrastructure&width=800&height=600&seq=smart-city&orientation=landscape'
    }
  ];

  return (
    <section id="solutions" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            현장사례
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            다양한 건설 프로젝트에 최적화된 맞춤형 계측 솔루션을 제공합니다
          </p>
        </div>
        
        <div className="space-y-16">
          {solutions.map((solution, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="flex-1">
                <div 
                  className="h-96 bg-cover bg-center rounded-xl shadow-lg"
                  style={{ backgroundImage: `url(${solution.image})` }}
                ></div>
              </div>
              <div className="flex-1">
                <h3 className="text-3xl font-bold text-gray-800 mb-4">
                  {solution.title}
                </h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  {solution.description}
                </p>
                <ul className="space-y-3 mb-8">
                  {solution.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-3">
                      <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
                <Button variant="primary" size="lg">
                  자세히 보기
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
